import {
  CalendarIcon,
  CompaniesListIcon,
  CompaniesSidebarIcon,
  EmployeesIcon,
  EnvelopeIcon,
  EvaluationsIcon,
  EventsIcon,
  GlobalIcon,
  HomeIcon,
  JoiningRequestsIcon,
  LogOutIcon,
  PromotionsIcon,
  RegistrationReqIcon,
  RequestsIcon,
  SeenNotificationIcon,
  SettingsIcon,
  TimesheetIcon,
} from "../../../utils/Icons";
import BuildUpIcon from "../SVG/BuildUpIcon";
import AlertCircleIcon from "../SVG/AlertCircleIcon";
import ApplicantsEmptyIcon from "../SVG/ApplicantsEmptyIcon";
import CalendarCloseIcon from "../SVG/CalendarCloseIcon";
import CalendarSvgIcon from "../SVG/CalendarIcon";
import CarIcon from "../SVG/CarIcon";
import CheckCalendarIcon from "../SVG/CheckCalendarIcon";
import ClockIcon from "../SVG/ClockIcon";
import ChevronDownIcon from "../SVG/ChevronDownIcon";
import ChevronRightSolidIcon from "../SVG/ChevronRightSolidIcon";
import ClipboardIcon from "../SVG/ClipboardIcon";
import CheckFileIcon from "../SVG/CheckFileIcon";
import CompanyBuildingIcon from "../SVG/CompanyBuildingIcon";
import DataIcon from "../SVG/DataIcon";
import DashboardIcon from "../SVG/Sidebar/DashboardIcon";
import DemoIcon from "../SVG/DemoIcon";
import ExportSheetIcon from "../SVG/ExportSheetIcon";
import FileListIcon from "../SVG/FileListIcon";
import FilterBarsIcon from "../SVG/FilterBarsIcon";
import IdUserIcon from "../SVG/IdUserIcon";
import InfoCircleIcon from "../SVG/InfoCircleIcon";
import ListIcon from "../SVG/ListIcon";
import LocationPinOutlinedIcon from "../SVG/LocationPinOutlinedIcon";
import PersonPlusIcon from "../SVG/PersonPlusIcon";
import PlusIcon from "../SVG/PlusIcon";
import RegistrationIcon from "../SVG/RegistrationIcon";
import Redo2Icon from "../SVG/Redo2Icon";
import RocketIcon from "../SVG/RocketIcon";
import Undo2Icon from "../SVG/Undo2Icon";
import Settings1Icon from "../SVG/Settings1Icon";
import StarsIcon from "../SVG/StarsIcon";
import SwapIcon from "../SVG/SwapIcon";
import TrashIcon from "../SVG/TrashIcon";
import TwoUsersIcon from "../SVG/TwoUsersIcon";
import UserIcon from "../SVG/UserIcon";
import ClientsIcon from "../SVG/Sidebar/ClientsIcon";
import CompanyIcon from "../SVG/Sidebar/CompanyIcon";
import SidebarEventsIcon from "../SVG/Sidebar/EventsIcon";
import SidebarLogoutIcon from "../SVG/Sidebar/LogoutIcon";
import RevenueIcon from "../SVG/Sidebar/RevenueIcon";
import FinanceIcon from "../SVG/Sidebar/FinanceIcon";
import SidebarRequestsIcon from "../SVG/Sidebar/RequestsIcon";
import Settings2Icon from "../SVG/Sidebar/Settings2Icon";
import UserPlusIcon from "../SVG/Sidebar/UserPlusIcon";
import UsersIcon from "../SVG/Sidebar/UsersIcon";
import MultipleUsersIcon from "../SVG/Sidebar/MultipleUsersIcon";
import FenceIcon from "../SVG/EventRequirements/FenceIcon";
import PullRopesIcon from "../SVG/EventRequirements/PullRopesIcon";
import PatrolCarIcon from "../SVG/EventRequirements/PatrolCarIcon";
import TrafficConeIcon from "../SVG/EventRequirements/TrafficConeIcon";
import LightStickIcon from "../SVG/EventRequirements/LightStickIcon";
import WaterBarrierIcon from "../SVG/EventRequirements/WaterBarrierIcon";

export const iconRegistry = {
  alertCircle: AlertCircleIcon,
  applicantsEmpty: ApplicantsEmptyIcon,
  applicants: UserPlusIcon,
  buildUp: BuildUpIcon,
  calendar: CalendarSvgIcon,
  calendarClose: CalendarCloseIcon,
  car: CarIcon,
  checkCalendar: CheckCalendarIcon,
  checkFile: CheckFileIcon,
  chevronDown: ChevronDownIcon,
  chevronRightSolid: ChevronRightSolidIcon,
  clients: ClientsIcon,
  clock: ClockIcon,
  clipboard: ClipboardIcon,
  company: CompanyIcon,
  companyBuilding: CompanyBuildingIcon,
  companies: CompaniesSidebarIcon,
  companiesList: CompaniesListIcon,
  dashboard: DashboardIcon,
  data: DataIcon,
  demo: DemoIcon,
  employees: EmployeesIcon,
  envelope: EnvelopeIcon,
  evaluations: EvaluationsIcon,
  eventRequirementFence: FenceIcon,
  eventRequirementLightStick: LightStickIcon,
  eventRequirementPatrolCar: PatrolCarIcon,
  eventRequirementPullRopes: PullRopesIcon,
  eventRequirementTrafficCone: TrafficConeIcon,
  eventRequirementWaterBarrier: WaterBarrierIcon,
  events: SidebarEventsIcon,
  exportSheet: ExportSheetIcon,
  fileList: FileListIcon,
  filterBars: FilterBarsIcon,
  finance: FinanceIcon,
  global: GlobalIcon,
  home: HomeIcon,
  idUser: IdUserIcon,
  infoCircle: InfoCircleIcon,
  joiningRequests: JoiningRequestsIcon,
  legacyCalendar: CalendarIcon,
  list: ListIcon,
  locationPin: LocationPinOutlinedIcon,
  logout: SidebarLogoutIcon,
  promotions: PromotionsIcon,
  personPlus: PersonPlusIcon,
  plus: PlusIcon,
  revenue: RevenueIcon,
  rocket: RocketIcon,
  registrationRequests: RegistrationReqIcon,
  registration: RegistrationIcon,
  redo2: Redo2Icon,
  requests: SidebarRequestsIcon,
  seenNotification: SeenNotificationIcon,
  settings: Settings2Icon,
  settings1: Settings1Icon,
  settings2: Settings2Icon,
  userPlus: UserPlusIcon,
  stars: StarsIcon,
  swap: SwapIcon,
  sidebarCompany: CompanyIcon,
  sidebarEvents: SidebarEventsIcon,
  sidebarLogout: SidebarLogoutIcon,
  sidebarRequests: SidebarRequestsIcon,
  timesheet: TimesheetIcon,
  trash: TrashIcon,
  undo2: Undo2Icon,
  twoUsers: TwoUsersIcon,
  user: UserIcon,
  users: UsersIcon,
  legacyEvents: EventsIcon,
  legacyLogout: LogOutIcon,
  legacyRequests: RequestsIcon,
  legacySettings: SettingsIcon,
  locationPinOutlined: LocationPinOutlinedIcon,
  multipleUsers: MultipleUsersIcon,
};

export const iconNames = Object.keys(iconRegistry);
